import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import OrderTotalCharges from '../../../components/OrderTotalCharges';
import OrderFeesSummary from './OrderFeesSummary';
import DiscountsSummary from './DiscountsSummary';
import CartInventoryContainer from '../containers/CartInventoryContainer';
import Props from './CartComponent';
import Button from 'shared/Button';
import AlertContainer from '../containers/AlertContainer';
import FocusTrap from '@s/FocusTrap';
import CartInventoryTable from './CartInventoryTable';
import CartInventoryTableProductRow from './CartInventoryTableProductRow';
import { getInitialFocusSelector } from '../../../helpers/helpers';
import Translation from "../../../../shared/Translation";
import EmptyState from '@s/EmptyState';
import EmbedFooter from '../../../components/EmbedFooter';
import { TranslationContext } from '../../../config/Translations';
import { ReservationTimer } from '@v/checkout/components/ReservationTimer';
import { ClearCartModal } from './ClearCartModal';

class Cart extends Component<Props> {
    constructor(props) {
        super(props);
        this.state = {
          isLoading: false,
          isClearCartModalOpen: false,
        };
    }

    onClearCartModalOpen = () => {
        this.setState({ isClearCartModalOpen: true });
    }

    onClearCartModalClose = () => {
        this.setState({ isClearCartModalOpen: false });
    }
    
    handleLoadingStatusChanged = (data) => {
        this.setState({ isLoading: data });
    };

    isCheckoutButtonLoading = () => {
      return this.state.isLoading || this.props.fetchLoading;
    }

    render() {
        return(
          <TranslationContext.Consumer>
            {({ t }) => (
              <FocusTrap
                  fallback = {'.top-cart-wrap'}
                  focusTrapOptions={{
                      initialFocus: getInitialFocusSelector('.editable-quantity__input'),
                  }}
              >
                  <div className="top-cart-wrap" tabIndex="-1">
                      <dialog 
                        className="cart-wrap"
                        aria-modal="true"
                        aria-label={`${t('checkout__cart_for_event', { event_name: this.props.eventName })}`}
                      >
                          <div className="cart-container">
                              { this.props.showSuccess && <div className="alert alert--success">
                                <p><Translation>{'checkout__discount_coupon_has_been_applied'}</Translation></p></div> }
                              <AlertContainer />
                              <div className='cart'>
                              <header className='cart__header'>
                                <div className='cart__header-inner'>
                                  <h1><Translation>{'checkout__edit_cart'}</Translation></h1>
                                  <Button className="button--clear close-cart-button" onClick={this.props.closeCart}>
                                    <i className="icon-close" />
                                  </Button>
                                </div>
                                <ReservationTimer time={this.props.time} />
                              </header>
                              {/*<header className="cart__header">
                                  <i className="icon-navigate_before" aria-hidden="true"></i>
                                  <div className="cart__icon">
                                      <i className="icon-shopping_cart" aria-hidden="true"></i>
                                  </div>
                                  <div className="cart__heading">Cart</div>
                              <div className="header__left">
                                      <h3 className="header__title cart__heading">Cart</h3>
                                  </div>
                                  <div className="header__right">
                                      <button onClick={ this.props.leaveCart } className="button--clear button--close">
                                          <i className="icon-close" aria-hidden="true"></i>
                                          <span className="sr-only">Close</span>
                                      </button>
                                  </div>
                              </header>*/}
                              <div className="cart__content">
                                  {this.cartContent()}
                              </div>
                              <footer className="cart__footer">
                                  {/* <ul className="accepted-cards">
                                      <li className="accepted-cards__item"><img src="//s3.amazonaws.com/sc-images-checkout/cc-visa.png" alt="Visa"></li>
                                      <li className="accepted-cards__item"><img src="//s3.amazonaws.com/sc-images-checkout/cc-mc.png" alt="Mastercard"></li>
                                      <li className="accepted-cards__item"><img src="//s3.amazonaws.com/sc-images-checkout/cc-disc.png" alt="Discover"></li>
                                      <li className="accepted-cards__item"><img src="//s3.amazonaws.com/sc-images-checkout/cc-amex.png" alt="American Express"></li>
                                      </ul> */}
                                <div className="cart__footer-actions">
                                  <div className="cart__footer-actions-top">
                                    {this.shouldShowTicketButton() && !this.props.reservedCoupon && (
                                      <Button
                                        onClick={this.props.onAddTickets}
                                        className={this.ticketButtonClass()}
                                        role='link'
                                        data-href={`#${this.props.isSeries ? "seriesDatePicker" : "ticketPicker"}`}
                                      >
                                        <Translation>{this.ticketButtonText()}</Translation>
                                      </Button>
                                    )}
                                    {this.props.hasCoupons && (
                                      <Button onClick={this.props.onShowDiscountCoupon} className="button--secondary coupon-entry__button"><i className='icon-tag' aria-hidden="true"></i><Translation>{'checkout__enter_promo_code'}</Translation></Button>
                                    )}
                                  </div>
                                  {!this.props.isEmpty && (
                                    <Button
                                      onClick={this.props.goToCheckout}
                                      className="button--primary button--large cart__button-checkout"
                                      loading={this.isCheckoutButtonLoading()}
                                      disabled={this.isCheckoutButtonLoading()}
                                      role="link"
                                      data-href={`#checkout/${this.props.token}`}
                                    >
                                      <Translation>{'checkout__go_to_checkout'}</Translation>
                                    </Button>
                                  )}
                                  <Fragment>
                                    <Button
                                      onClick={this.onClearCartModalOpen}
                                      className="button--clear cart__button-cancel"
                                    >
                                      <Translation>{'checkout__clear_cart'}</Translation>
                                    </Button>
                                    <ClearCartModal
                                      open={this.state.isClearCartModalOpen}
                                      loading={this.props.deleteLoading}
                                      onClear={this.props.clearCart}
                                      onClose={this.onClearCartModalClose}
                                    />
                                  </Fragment>
                                </div>
                                <EmbedFooter />
                              </footer>
                            </div>
                          </div>
                      </dialog>
                  </div>
              </FocusTrap>
             )}
          </TranslationContext.Consumer>
        )
    }

    cartContent = () => {
        if (this.props.isEmpty) {
            return (
            <div className="cart__empty-state">
                <EmptyState
                    iconSize={EmptyState.iconSize.large}
                    spacing={EmptyState.spacing.large}
                    icon="icon-ticket-thin"
                    title="Your cart is empty"
                    message="Add some tickets to your cart to start a reservation"
                />
            </div>
            );
        }

        return (
            <Fragment>
                {this.renderEventSummaries()}
                {this.renderUpsoldProducts()}
                <OrderFeesSummary fees={this.props.fees}/>
                <DiscountsSummary coupon={this.props.coupon} currencySymbol={this.props.currencySymbol} hasAutoCoupons={this.props.hasAutoCoupons}/>
                {/*<section className="cart__coupons">*/}
                    {/*<DiscountSummary />*/}
                {/*</section>*/}
                <footer className="cart__items-total">
                    <OrderTotalCharges total={this.props.total}/>
                </footer>
            </Fragment>
        );
    }

    shouldShowTicketButton = () => {
      // If that's a multi embed - hide this button
      return this.props.canAddMoreTickets && !this.props.isMultiEmbed;
    }

    ticketButtonText = () => {
        if (this.props.isEmpty) {
            return 'checkout__add_tickets';
        }
        return this.props.isPyos && !this.props.isDynamic ? 'checkout__edit_seat_selection' : 'checkout__add_more_tickets';
    }

    ticketButtonClass = () => {
        return `${this.props.isEmpty ? 'button--primary' : 'button--secondary'} cart__button-back`;
    }

    renderEventSummaries = () => {
        return this.props.eventIds.map((eventId, i) => {
            return <CartInventoryContainer key={i} eventId={eventId} onLoadingStatusChanged={this.handleLoadingStatusChanged} />
        });
    }

    productSelectionChange = (value, configurationId) => {
        this.props.updateProductQuantities({products: [{quantity: value, product_configuration_id: configurationId, event_id: this.props.eventId}]}, this.props.token, this.props.secret);
    };

    /**
     * Show upsold products under "Add-ons" header below items from listing event and upsold events
     */
    renderUpsoldProducts = () => {
        if (typeof this.props.upsoldProducts === 'object' && !!Object.keys(this.props.upsoldProducts).length) {
            return (
                <CartInventoryTable
                    header={(
                        <h4 className="cart__event-info__name" aria-level="2">Add-ons</h4>
                    )}
                    body={Object.keys(this.props.upsoldProducts).map((upsellId) => {
                        const products = this.props.upsoldProducts[upsellId];
                        if (Array.isArray(products)) {
                            return products.map((product, index) => {
                                return (
                                    <CartInventoryTableProductRow
                                        key={`${upsellId}_${index}`}
                                        product={product}
                                        loading={this.props?.loadingStates?.[`PRODUCT_QUANTITY_UPSELL_${upsellId}_${product.configuration_id}`] === 'REQUEST'}
                                        onIncrement={() => {
                                            const payload = {
                                                products: [
                                                    {
                                                        quantity: product.quantity + 1,
                                                        product_configuration_id: product.configuration_id,
                                                    }
                                                ]
                                            }
                                            this.props.onUpdateProductQuantities(payload, this.props.token, this.props.secret, true, upsellId);
                                        }}
                                        onDecrement={() => {
                                            const payload = {
                                                products: [
                                                    {
                                                        quantity: product.quantity - 1,
                                                        product_configuration_id: product.configuration_id,
                                                    }
                                                ]
                                            }
                                            this.props.onUpdateProductQuantities(payload, this.props.token, this.props.secret, true, upsellId);
                                        }}
                                        onQuantityInput={e => {
                                            const payload = {
                                                products: [
                                                    {
                                                        quantity: e.target.value,
                                                        product_configuration_id: product.configuration_id,
                                                    }
                                                ]
                                            }
                                            this.props.onUpdateProductQuantities(payload, this.props.token, this.props.secret, true, upsellId);
                                        }}
                                        onRemove={e => {
                                            const payload = {
                                                products: [
                                                    {
                                                        quantity: 0,
                                                        product_configuration_id: product.configuration_id,
                                                    }
                                                ]
                                            }
                                            this.props.onUpdateProductQuantities(payload, this.props.token, this.props.secret, true, upsellId);
                                        }}
                                        quantity={product.quantity}
                                    />
                                );
                            });
                        }
                        return null;
                    })}
                />
            );
        }
        return null;
    }
}

Cart.propTypes = {
    total: PropTypes.number.isRequired,
    goToCheckout: PropTypes.func.isRequired,
    clearCart: PropTypes.func.isRequired,
    fees: PropTypes.array,
    listings: PropTypes.array.isRequired,
    hasCoupons: PropTypes.bool,
    onShowDiscountCoupon: PropTypes.func,
    showSuccess: PropTypes.bool,
    coupon: PropTypes.object,
    currencySymbol: PropTypes.string,
    hasAutoCoupons: PropTypes.bool,
    deleteLoading: PropTypes.bool.isRequired,
    eventIds: PropTypes.array.isRequired,
    onUpdateProductQuantities: PropTypes.func.isRequired,
    isPyos: PropTypes.bool,
    isEmpty: PropTypes.bool,
    reservedCoupon: PropTypes.bool,
    isMultiEmbed: PropTypes.bool,
    eventName: PropTypes.string,
}

Cart.defaultProps = {
    canAddMoreTickets: true,
}

export default Cart
